import React from "react";
import CardClass from "../../../CardClass";
import MUITextField from "@mui/material/TextField";
import MUIGrid from "@mui/material/Grid";
import MUIAutocomplete from "@mui/material/Autocomplete";

export default class CardAdminTermGeneral extends CardClass {
  /**
   * Render the content of the card.
   */
  renderContent() {
    const typeAutocompleteOptions = this.props.typeOptions || [];
    const selectedTypeValue = this.props.selectedType || null;
    const selectedTypeOption =
      typeAutocompleteOptions.find(
        (option) => option.value === selectedTypeValue,
      ) || null;

    return (
      <MUIGrid container spacing={2}>
        {this.props.showTypeField && (
          <MUIGrid item xs={12} sm={6} md={4}>
            <MUIAutocomplete
              freeSolo={true}
              size="small"
              options={typeAutocompleteOptions}
              value={selectedTypeOption}
              inputValue={this.props.typeInputValue || ""}
              fullWidth={true}
              getOptionLabel={(option) =>
                typeof option === "string" ? option : option.label
              }
              isOptionEqualToValue={(option, value) =>
                option.value === value.value
              }
              onChange={(e, option) => this.props.onTypeChange(option)}
              onInputChange={(e, value, reason) =>
                this.props.onTypeInputChange(value, reason)
              }
              renderInput={(params) => (
                <MUITextField
                  {...params}
                  label="Type"
                  variant="standard"
                  required={true}
                  InputLabelProps={{ shrink: true }}
                  error={!!this.props.validationIssues.type}
                  helperText={this.props.validationIssues.type || ""}
                />
              )}
            />
          </MUIGrid>
        )}
        {this.props.showTypeReadOnly && (
          <MUIGrid item xs={12} sm={6} md={4}>
            <MUITextField
              value={this.props.typeValue || ""}
              size="small"
              label="Type"
              variant="standard"
              fullWidth={true}
              InputLabelProps={{ shrink: true }}
              disabled={true}
            />
          </MUIGrid>
        )}
        <MUIGrid item xs={12} sm={6} md={4}>
          <MUITextField
            value={this.props.term ? this.props.term.name : ""}
            autoFocus={true}
            size="small"
            label="Name"
            variant="standard"
            fullWidth={true}
            inputProps={{
              maxLength: 255,
            }}
            InputLabelProps={{ shrink: true }}
            onBlur={(e) => this.props.onChange({ name: e.target.value.trim() })}
            onChange={(e) => this.props.onChange({ name: e.target.value })}
            required={true}
            error={this.props.validationIssues.name ? true : false}
            helperText={
              this.props.validationIssues.name
                ? this.props.validationIssues.name
                : ""
            }
          />
        </MUIGrid>
      </MUIGrid>
    );
  }

  /**
   * @returns {string} The title of the card.
   */
  getTitle() {
    return "General";
  }
}
